import { z } from "zod";

export const getPartnerStatisticsFilterFormSchema = () => {
	return z.object({
		marketId: z.number().nullish(),
		regionId: z.number().nullish(),
	});
};

export type PartnerStatisticsFilterFormModel = z.infer<
	ReturnType<typeof getPartnerStatisticsFilterFormSchema>
>;
